import { PhysicalFeaturesSearchDto } from '@app/api2/api';
import * as Yup from 'yup';

export const PhysicalFeaturesSearchSchema: Yup.SchemaOf<PhysicalFeaturesSearchDto> = Yup.object({
    discriminator: Yup.string().required(),
    operator: Yup.string().optional(),
    featureType: Yup.number().required('Feature Type is required'),
    description: Yup.string().optional(),
});
